import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store} from '@ngrx/store';
import * as fromRoot from '../../../../../store/reducers';
import { RestService } from '../../../../../service/rest.service';
import swal from 'sweetalert2';
import * as messageActions from '../../../../../store/actions/messages';
import { AppMessages } from '../../../../../shared/configs/app.messages';
import { FormControl } from '@angular/forms';
import { VpoName } from '../../../../../models/vpo.model';
import { ServerDTO } from '../../../../../models/app.model';
import { dtoFormatter, typeCaster } from '../../../../../shared/helpers/helper.system';
import { Moment } from 'moment';
import { AppAlerts } from '../../../../../shared/configs/app.alerts';


interface MailFilter {
  idVpo: string;
  dateFrom: Moment;
  dateTo: Moment;
}

@Component({
  selector: 'app-mail-forward',
  templateUrl: './mail-forward-dialog.component.html',
  styleUrls: ['./mail-forward-dialog.component.scss']
})
export class MailForwardDialogComponent implements OnInit {

  // for vpo select
  vpoControl: FormControl;
  // vpo names
  vpoNames: Array<VpoName> = [];
  filter: MailFilter = <MailFilter>{};
  isForwardReady: boolean = false;
  isForwarding: boolean = false;
  selectedIds: Array<string> = [];
  errorIds: Array<string> = [];
  successIds: Array<string> = [];

  constructor(/*public dialogRef: MatDialogRef<MailForwardDialogComponent>,*/
              private store: Store<fromRoot.AppState>,
              private restService: RestService) {
    this.vpoControl = new FormControl();
  }

  ngOnInit() {
    // get vpo
    this.restService.getVpoActive()
      .subscribe((p: ServerDTO) => {
        this.vpoNames = dtoFormatter<VpoName>(p);
      });
  }

  private _getFilter() {
    return Object.keys(this.filter).map( key => {
      let value = this.filter[key];
      value = key === 'dateTo' ? this.filter[key].format('YYYY-MM-DD') : value;
      value = key === 'dateFrom' ? this.filter[key].format('YYYY-MM-DD') : value;
      return key + '=' + value; // encodeURIComponent
    }).join('&');
  }

  /**
   * For autocomplete selects
   */
  displayFn(s?: any): string | undefined {
    return s ? (s.name || s.title) : undefined;
  }

  selectVpo(event) {
    this.filter.idVpo = typeCaster<VpoName>(event.source.value).id;
    this.changeFilter();
  }

  selectComplaints() {

    if ( !Object.keys(this.filter).length ) {
      swal({
        title: AppAlerts.OBJECT_IS_EMPTY,
        type: 'error',
      });
      return;
    }

    const filter = this._getFilter();
    this.restService.getComplaintIdsByFilter(filter)
      .subscribe( (p: ServerDTO) => {
        this.selectedIds = p.rows ? p.rows.map( r => r.id) : [];
        this.isForwardReady = true;
      });
  }

  clearFilter() {
    this.filter = <MailFilter>{};
    this.vpoControl.setValue(null);
    this.changeFilter();
  }

  changeFilter() {
    this.isForwardReady = false;
  }

  forwardAll() {

    const _this = this;
    this.isForwarding = true;
    this.errorIds = [];
    this.successIds = [];

    swal({
      title: 'Надеюсь вы понимаете, что делаете?',
      text: 'Данным действием вы повторно перенаправите выбранные обращения адресатам - военным прокуратурам. Не рекомендуется ' +
        ' делать при большом количестве поступивших обращений!!!',
      type: 'warning',
      showCancelButton: true,
    }).then(function (action) {
      _this.selectedIds.forEach( id => {
        _this.restService.forwardComplaintById(id)
          .subscribe(
            () => {
              _this.successIds.push(id);
              if (_this.successIds.length === _this.selectedIds.length) {
                _this.isForwarding = false;
                _this.isForwardReady = false;
                _this.clearFilter();
                _this.store.dispatch(new messageActions.SuccessMessage(AppMessages.COMPLAINT_FORWARD_SUCCESS_ALL));
              }
            },
            () => _this.errorIds.push(id)
            );
          });
      });

    }
}
